/**
 * Builds a fast-test polygon from the stored points array [{lat, long}].
 * Pre-computes a bounding box so most points can be rejected in O(1) before
 * the ray cast runs.
 * Returns null if the points form an invalid polygon (< 3 valid vertices).
 */
export function buildPolygon(points) {
  const ring = [];
  let minLat = Infinity,
    maxLat = -Infinity,
    minLng = Infinity,
    maxLng = -Infinity;
  for (const p of points || []) {
    const lat = parseFloat(p?.lat);
    const lng = parseFloat(p?.long);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) continue;
    ring.push([lat, lng]);
    if (lat < minLat) minLat = lat;
    if (lat > maxLat) maxLat = lat;
    if (lng < minLng) minLng = lng;
    if (lng > maxLng) maxLng = lng;
  }
  if (ring.length < 3) return null;
  return { ring, minLat, maxLat, minLng, maxLng };
}

function pointInRing(lat, lng, ring) {
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [yi, xi] = ring[i];
    const [yj, xj] = ring[j];
    const intersect =
      yi > lat !== yj > lat && lng < ((xj - xi) * (lat - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}

/**
 * Returns true if the point [lat, lng] is inside ANY of the provided polygons.
 */
export function pointInAnyPolygon(lat, lng, polygons) {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false;
  for (const poly of polygons) {
    if (
      lat < poly.minLat ||
      lat > poly.maxLat ||
      lng < poly.minLng ||
      lng > poly.maxLng
    )
      continue;
    if (pointInRing(lat, lng, poly.ring)) return true;
  }
  return false;
}
